<ng-container *ngIf="engine">
    <div class="display-flex-row titles-row fill-width">
        <div class="column text-column">
            <span class="aum-typo-label-l title">
                {{ 'aumico_templates_template_account_mapping_form_mapped_accounts' | i18next }}
            </span>
        </div>

        <div class="column action-column">
            <div>
                <span *ngIf="isExpanded" class="aum-typo-label hide-show-action" (click)="collapse()">
                    {{ 'aumico_templates_template_account_mapping_form_hide_details' | i18next }}
                </span>
                <span *ngIf="!isExpanded" class="aum-typo-label hide-show-action" (click)="expand()">
                    {{ 'aumico_templates_template_account_mapping_form_show_details' | i18next }}
                </span>
            </div>
        </div>
    </div>

    <div class="display-flex-row fill-width">
        <div class="column text-column">
            <span class="aum-typo-table-header">
                {{ currency }}
            </span>
        </div>
        <div class="column value-column">
            <span class="aum-typo-table-header dates">{{ dates.endDate | dateLocale }}</span>
        </div>
        <div class="column value-column">
            <span class="aum-typo-table-header dates">{{ dates.startDate | dateLocale }}</span>
        </div>
        <div class="column action-column">
            <span class="aum-typo-table-header action-column-placeholder"></span>
        </div>
        <div class="column column-empty-placeholder"></div>
    </div>
    <div class="separator"></div>

    <ng-container *ngFor="let delegate of delegates; index as index">
        <ng-container *ngIf="delegate != null && delegate.templateGroup != null">
            <ng-container *ngIf="index != 0"> <br /><br /><br /> </ng-container>
            <templates-group-account-mapping
                [businessModel]="businessModel"
                [reportLocale]="reportLocale"
                [languages]="languages"
                [defaultLanguage]="defaultLanguage"
                [delegate]="delegate"
                [touched]="touched"
                [isCollapseButtonClicked]="isCollapseButtonClicked"
                [type]="type"
                [hasPreviousData]="hasPreviousData"
                [cashAndCashFli]="cashAndCashFli"
                [profitOfTheYearFliName]="profitOfTheYearFliName"
                [errorInProfitFli]="errorInProfitFli"
                [isAutomaticTransferOfAnnualResultEnabled]="isAutomaticTransferOfAnnualResultEnabled"
                [engine]="engine"
                [isCashFlowTypeForFliUsed]="isCashFlowTypeForFliUsed"
                [disableEditingPreviousYearValue]="disableEditingPreviousYearValue"
                [supportOperation]="supportOperation"
                (addOrUpdateAccountInActiveReport)="onAddOrUpdateActiveReport($event)"
                (fliOrGroupDeleted)="onFliOrGroupDeleted($event)"
            >
            </templates-group-account-mapping>
        </ng-container>
    </ng-container>
</ng-container>
